import { Content, ContentProps } from "../../Content";

export function ContentWithData<Data extends Record<string, unknown>>(
  props: ContentWithDataProps<Data>
) {
  return <Content {...props} />;
}

type ContentWithDataProps<Data extends Record<string, unknown>> = Omit<
  ContentProps,
  "data"
> & { data: Data };
